import { useParams } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { useBrand } from "@/components/news/Brand";

const TITLES = { disclaimer: "Disclaimer", copyright: "Copyright", contact: "Contact us" };

export default function StaticPage() {
  const { key } = useParams();
  const { settings } = useSite();
  const brand = useBrand();
  const title = TITLES[key] || "Page not found";

  return (
    <div data-testid={`static-page-${key}`} className="max-w-3xl mx-auto px-4 sm:px-6 py-16 fade-in">
      <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#1D4ED8]">{brand.name} · {brand.tagline}</p>
      <h1 className="mt-2 font-serif-head font-black text-4xl sm:text-5xl tracking-tight border-b-2 border-zinc-900 pb-6">{title}</h1>
      {key === "contact" ? (
        <ul className="mt-10 space-y-6 text-lg">
          <li data-testid="contact-email" className="flex gap-3"><Mail className="h-5 w-5 mt-1" /> {settings.contact_email}</li>
          <li data-testid="contact-phone" className="flex gap-3"><Phone className="h-5 w-5 mt-1" /> {settings.contact_phone}</li>
          <li data-testid="contact-address" className="flex gap-3"><MapPin className="h-5 w-5 mt-1" /> <span className="whitespace-pre-line">{settings.contact_address}</span></li>
        </ul>
      ) : (
        <div data-testid="static-page-body" className="mt-10 text-lg leading-relaxed text-zinc-700 whitespace-pre-line">
          {TITLES[key] ? settings[key] : "This page does not exist."}
        </div>
      )}
    </div>
  );
}
